/* eslint-disable warp-drive/no-legacy-request-patterns */
import { service } from '@ember/service';
import Route from '@ember/routing/route';

import Resource from 'linced-app/enums/enrolment-resource';
import Jurisdiction from '@linc-technologies/linced-common/enums/jurisdiction';
import { hash } from '@linc-technologies/linced-common/utils/promise';

export default class RollReturnRoute extends Route {
  // Services
  @service
  store;

  model(params) {
    return hash({
      rollReturn: this.store.findRecord(
        'nz-roll-returns/roll-return',
        params.roll_return_id,
      ),
      validationResults: this.store.query('nz-roll-returns/validation-result', {
        rollReturnId: params.roll_return_id,
      }),
      uploadStatuses: this.store.query('enrolments/status', {
        jurisdiction: Jurisdiction.NZ_MOE,
        resource: Resource.ROLL_RETURN,
        returnId: params.roll_return_id,
      }),
    });
  }

  // afterModel loads the resources of each upload status, which show the DEX
  // errors.
  afterModel(model) {
    return Promise.all(
      (model.uploadStatuses ?? []).map((status) => status.loadResources()),
    );
  }
}
